function InitSlideAnimation(){

  jQuery(function() {
    jQuery(window).scroll(function() {
    if(jQuery('.animated__element').length > 0){
        var animated_elements = jQuery.find('.animated__element');
        jQuery.each(animated_elements, function() {
           let oTop = jQuery(this).offset().top - window.innerHeight;
            if (jQuery(window).scrollTop() > oTop) {
              jQuery(this).addClass('in-view');
            }
        });
    }
    });
  });


}

export default InitSlideAnimation;